<template>
  <div>
    <b-collapse
      class="card"
      :open.sync="searchOpen"
      style="margin-bottom: 2rem"
    >
      <div slot="trigger" class="card-header">
        <div class="card-header-title">
          <a>
            <b-icon :icon="searchOpen ? 'angle-down' : 'angle-right'"></b-icon>
          </a>
          <translate>list.options.adjust.searchparameters</translate>
        </div>
        <div class="card-header-icon">
          <span class="has-text-basalt">
            {{ total }} {{ total === 1 ? $gettext('list.total') : $gettext('list.total.plural') }}
          </span>
        </div>
      </div>
      <div class="card-content" style="padding-top: 0; padding-bottom: 3rem;">
        <div :key="filterSchema.label">
          <fob-entity-create-form
            ref="fobEntityCreateForm"
            :schema="filterSchema"
            v-model="filter"
          ></fob-entity-create-form>
        </div>
      </div>
    </b-collapse>
    <div class="fob-only-for-print-view">
      <div class="print-metadata-box">
        <div class="print-metadata-columns">
          <div class="print-metadata-label"><translate>tag.static.researchActivity</translate></div>
          <div class="print-metadata-value"><translate>{{this.filterSchema.label}}</translate></div>
        </div>
        <div class="print-metadata-columns">
          <div class="print-metadata-label"><translate>tag.static.printedPageOfPagesLabel</translate></div>
          <div class="print-metadata-value"><translate :translate-params="{page, totalTablePages}">tag.static.printedPageOfPagesValue</translate></div>
        </div>
        <div class="print-metadata-columns">
          <div class="print-metadata-label"><translate>tag.static.resultCount</translate></div>
          <div class="print-metadata-value">{{this.total}}</div>
        </div>
        <div class="print-metadata-columns">
          <div class="print-metadata-label"><translate>tag.static.entriesPerPage</translate></div>
          <div class="print-metadata-value">{{this.perPage}}</div>
        </div>
      </div>
    </div>
    <transition name="tags">
      <b-field class="fob-entity-list-filter-tags" v-show="!searchOpen && hasActiveFilters" grouped group-multiline>
        <transition-group class="fob-entity-list-options-tag-list-dynamic" name="tag-list">
          <div v-for="(value, field) in activeFilter" :key="field">
            <b-taglist attached>
              <b-tag type="is-aquamarine">
                {{ $gettext(schemaBitForField(field).label) }}
              </b-tag>
              <b-tag type="is-basalt" closable @close="removeTag(field)">
                <fob-entity-value
                  :plain="true"
                  :bit="schemaBitForField(field)"
                  :resourceData="value"
                  :maxLength="30"
                ></fob-entity-value>
              </b-tag>
            </b-taglist>
          </div>
        </transition-group>
      </b-field>
    </transition>
  </div>
</template>

<script>
// COMPONENTS
import EntitySelect from '@/components/form/EntitySelect'
import EntityCreateForm from '@/components/form/EntityCreateForm'
import EntityValue from '@/components/EntityValue'

export default {
  data () {
    return {
      searchOpen: false,
      visibilityOpen: false
    }
  },
  props: [
    'filterSchema',
    'page',
    'perPage',
    'tableFields',
    'total',
    'value'
  ],
  computed: {
    filter: {
      get () {
        return this.value
      },
      set (newValue) {
        this.$emit('input', newValue)
      }
    },
    activeFilter () {
      let activeFilter = {}
      for (let fieldSchema of this.filterSchema.fields) {
        let key = fieldSchema.field
        let value = this.filter[key]
        if (value != null && value !== '' && value !== false && (value.name !== '' || false)) {
          activeFilter[key] = value
        }
      }
      return activeFilter
    },
    hasActiveFilters () {
      return Object.keys(this.activeFilter).length > 0
    },
    totalTablePages () {
      return Math.ceil(this.total / this.perPage)
    }
  },
  methods: {
    emitChange () {
      this.$emit('input', this.filter)
    },
    schemaBitForField (field) {
      return this.filterSchema.fields.find(x => x.field === field)
    },
    removeTag (field) {
      let schemaBit = this.filterSchema.fields.find(x => x.field === field)
      if (schemaBit.type === 'object') {
        /*
        Call emptyField() von createForm which in turn calls emptyField() on the
        entitySelect component. This is needed to remove not only the value in
        the filter object but to reset the enitySelect field as well.
        */
        this.$refs.fobEntityCreateForm.emptyField(field)
      } else {
        this.filter[field] = null
      }
    }
  },
  components: {
    'fob-entity-select': EntitySelect,
    'fob-entity-value': EntityValue,
    'fob-entity-create-form': EntityCreateForm
  }
}
</script>

<style lang="scss">
  .tags-item {
    transition: all 0.5s;
  }
  .tags-enter, .formfields-leave-to {
    transition: all 0.5s;
    opacity: 0;
    transform: translateX(30px);
  }
  .tags-move {
    transition: transform 0.25s;
  }
  .tags-leave-active {
    position: absolute;
  }
  .tags-enter-active, .formfields-leave-active {
    transition: all 1s;
    transition-delay: 0.25s;
  }

  .tag-list-leave-active {
    position: absolute;
  }
  .tag-list-enter-active, .tag-list-leave-active {
    transition: all 0.5s;
  }
  .tag-list-enter, .tag-list-leave-to {
    opacity: 0;
  }
  .tag-list-move {
    transition: transform 0.5s;
  }

  .fob-entity-list-filter-tags {
     margin-bottom: 1.5rem !important;
  }

  .fob-entity-list-options-tag-list-static {
    width: 100%;

    .tags {
      .tag {
        border: solid 1px black !important;
      }
    }
  }

  .fob-entity-list-options-tag-list-dynamic {
    display: flex; flex-flow: row wrap;
  }

  .tags {
    margin: 0 0.5rem 0rem  0 !important;
  }

  .print-metadata-box {
    width: 275px;
    border: black solid 1px;
    border-radius: 2px;
    font-size: 10px !important;
    position: absolute;
    right: 0px;
    top: 0px;

    .print-metadata-columns {
      display: flex;
      justify-content: flex-end;
      margin-left: 5px;

      .print-metadata-label {
        flex: none;
        width: 50%;
        padding: 0px;
      }

      .print-metadata-value {
        display: block;
        flex-basis: 0;
        flex-shrink: 1;
        flex-grow: 1;
        padding: 0px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/EntityListOptions.vue